import React from "react";

const Footer = () => {
  return (
    <div className="text-center footer-container">
      MARK ANJO S. GALISA ©2020
    </div>
  );
};

export default Footer;
